<c-row *ngIf="Add">
    <c-col xs="12">
        <c-card class="mb-4">
            <c-card-body>
                <button (click)="listBlog()">Back to List</button>
                <form [formGroup]="form" (ngSubmit)="submitForm()">
                    <c-row class="mb-">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="mainTitle">Main Title</label>
                            <input id="facebookLink" aria-label="mainTitle" cFormControl autoComplete="off"
                                formControlName="mainTitle" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.mainTitle">{{ serverErrors.mainTitle
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="mainParagraph">Main Paragraph </label>
                            <input id="mainParagraph" aria-label="mainParagraph" cFormControl autoComplete="off"
                                formControlName="mainParagraph" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.mainParagraph">{{ serverErrors.mainParagraph }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="image">Upload Image</label>
                            <input cFormControl id="image" sizing="md" type="file" (change)="upload($event)" />
                            <div class="form-group">
                                <div class="preview mt-2" *ngIf="preview && preview !== null">
                                    <img [src]="preview" [alt]="form.value.name">
                                </div>
                                <span class="required" *ngIf="serverErrors?.image">{{
                                    serverErrors.image
                                    }}</span>
                            </div>
                        </c-col>
                        <c-col></c-col>
                    </c-row>
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="coinName">Coin Name</label>
                            <input id="coinName" aria-label="coinName" cFormControl autoComplete="off"
                                formControlName="coinName" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.coinName">{{ serverErrors.coinName
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="coinParagraph">Coin Paragraph</label>
                            <input id="coinParagraph" aria-label="coinParagraph" cFormControl autoComplete="off"
                                formControlName="coinParagraph" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.coinParagraph">{{ serverErrors.coinParagraph }}</span>
                        </c-col>
                    </c-row>
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle1">paragraph Title1</label>
                            <input id="paragraphTitle1" aria-label="paragraphTitle1" cFormControl autoComplete="off"
                                formControlName="paragraphTitle1" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle1">{{ serverErrors.paragraphTitle1
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription1">Paragraph Description1</label>
                            <input id="paragraphDescription1" aria-label="paragraphDescription1" cFormControl autoComplete="off"
                                formControlName="paragraphDescription1" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription1">{{ serverErrors.paragraphDescription1 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle2">paragraph Title2</label>
                            <input id="paragraphTitle2" aria-label="paragraphTitle2" cFormControl autoComplete="off"
                                formControlName="paragraphTitle2" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle2">{{ serverErrors.paragraphTitle2
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription2">Paragraph Description2</label>
                            <input id="paragraphDescription2" aria-label="paragraphDescription2" cFormControl autoComplete="off"
                                formControlName="paragraphDescription2" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription2">{{ serverErrors.paragraphDescription2 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle3">paragraph Title3</label>
                            <input id="paragraphTitle3" aria-label="paragraphTitle3" cFormControl autoComplete="off"
                                formControlName="paragraphTitle3" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle3">{{ serverErrors.paragraphTitle3
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription3">Paragraph Description3</label>
                            <input id="paragraphDescription3" aria-label="paragraphDescription3" cFormControl autoComplete="off"
                                formControlName="paragraphDescription3" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription3">{{ serverErrors.paragraphDescription3 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle4">paragraph Title4</label>
                            <input id="paragraphTitle4" aria-label="paragraphTitle4" cFormControl autoComplete="off"
                                formControlName="paragraphTitle4" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle4">{{ serverErrors.paragraphTitle4
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription4">Paragraph Description4</label>
                            <input id="paragraphDescription4" aria-label="paragraphDescription4" cFormControl autoComplete="off"
                                formControlName="paragraphDescription4" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription4">{{ serverErrors.paragraphDescription4 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle5">paragraph Title5</label>
                            <input id="paragraphTitle5" aria-label="paragraphTitle5" cFormControl autoComplete="off"
                                formControlName="paragraphTitle5" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle5">{{ serverErrors.paragraphTitle5
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription5">Paragraph Description5</label>
                            <input id="paragraphDescription5" aria-label="paragraphDescription5" cFormControl autoComplete="off"
                                formControlName="paragraphDescription5" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription5">{{ serverErrors.paragraphDescription5 }}</span>
                        </c-col>
                    </c-row>

                         <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="graphImage">Upload Graph Image</label>
                            <input cFormControl id="graphImage" sizing="md" type="file" (change)="upload2($event)" />
                            <div class="form-group">
                                <div class="preview mt-2" *ngIf="preview2 && preview2 !== null">
                                    <img [src]="preview2" [alt]="form.value.name">
                                </div>
                                <span class="required" *ngIf="serverErrors?.graphImage">{{
                                    serverErrors.graphImage
                                    }}</span>
                            </div>
                        </c-col>
                        <c-col></c-col>
                    </c-row>
       
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="supportIndicator">support Indicator</label>
                            <input id="supportIndicator" aria-label="supportIndicator" cFormControl autoComplete="off"
                                formControlName="supportIndicator" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.supportIndicator">{{
                                serverErrors.supportIndicator }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="resistanceIndicator">resistance Indicator</label>
                            <input id="resistanceIndicator" aria-label="resistanceIndicator" cFormControl autoComplete="off"
                                formControlName="resistanceIndicator" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.resistanceIndicator">{{ serverErrors.resistanceIndicator
                                }}</span>
                        </c-col>
                    </c-row>

                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="dayEMA">Day EMA</label>
                            <input id="dayEMA" aria-label="dayEMA" cFormControl autoComplete="off"
                                formControlName="dayEMA" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.dayEMA">{{
                                serverErrors.dayEMA }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="RSI">RSI Indicator</label>
                            <input id="RSI" aria-label="RSI" cFormControl autoComplete="off"
                                formControlName="RSI" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.RSI">{{ serverErrors.RSI
                                }}</span>
                        </c-col>
                    </c-row>

                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="dailyPridiction">Daily Pridiction</label>
                            <input id="dailyPridiction" aria-label="dailyPridiction" cFormControl autoComplete="off"
                                formControlName="dailyPridiction" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.dailyPridiction">{{
                                serverErrors.dailyPridiction }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="weeklyPridiction">Weekly Pridiction</label>
                            <input id="weeklyPridiction" aria-label="weeklyPridiction" cFormControl autoComplete="off"
                                formControlName="weeklyPridiction" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.weeklyPridiction">{{ serverErrors.weeklyPridiction
                                }}</span>
                        </c-col>
                    </c-row>
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="yearlyPridiction">yearly Pridiction</label>
                            <input id="yearlyPridiction" aria-label="yearlyPridiction" cFormControl autoComplete="off"
                                formControlName="yearlyPridiction" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.yearlyPridiction">{{ serverErrors.yearlyPridiction
                                }}</span>
                        </c-col>
                   
                    </c-row>
      
                    <c-row>
                        <c-col [xs]="12">
                            <button cButton class="btn btn-primary" type="submit">Submit</button>
                        </c-col>
                    </c-row>
                </form>
            </c-card-body>
        </c-card>
    </c-col>
</c-row>

<c-row *ngIf="!Add && !Edit">
  <c-col xs="12">
    <c-card>
      <c-card-header>
        <strong>Blog List</strong>  
        ,     
      </c-card-header>
      <c-card-body>
        <div>
            <button (click)="addBlog()">Add Blog</button>
          <table class="table table-bordered table-striped table-responsive">
            <thead>
              <tr>
                <th>Main Title</th>
                <th>Main Paragraph</th>
                <th>Image</th>
                <th>Coin Name</th>
                <th>Coin Paragraph</th>
                <th>Paragraphs</th>
                <th>Graph Image</th>
                <th>Support</th>
                <th>Resistance</th>
                <th>Day EMA</th>
                <th>RSI</th>
                <th>Daily Prediction</th>
                <th>Weekly Prediction</th>
                <th>Yearly Prediction</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let blog of blogs">
                <td>{{ blog.mainTitle }}</td>
                <td>{{ blog.mainParagraph }}</td>
                <td>
               <img *ngIf="blog.image" [src]="path + '/slider/' + blog.image" alt="Blog Image" width="80" />
                 </td>
                <td>{{ blog.coinName }}</td>
                <td>{{ blog.coinParagraph }}</td>
                <td>
                  <ul>
                    <li *ngIf="blog.paragraphTitle1">{{ blog.paragraphTitle1 }}: {{ blog.paragraphDescription1 }}</li>
                    <li *ngIf="blog.paragraphTitle2">{{ blog.paragraphTitle2 }}: {{ blog.paragraphDescription2 }}</li>
                    <li *ngIf="blog.paragraphTitle3">{{ blog.paragraphTitle3 }}: {{ blog.paragraphDescription3 }}</li>
                    <li *ngIf="blog.paragraphTitle4">{{ blog.paragraphTitle4 }}: {{ blog.paragraphDescription4 }}</li>
                    <li *ngIf="blog.paragraphTitle5">{{ blog.paragraphTitle5 }}: {{ blog.paragraphDescription5 }}</li>
                  </ul>
                </td>
                <td>
                  <img *ngIf="blog.graphImage" [src]="path + '/slider/' + blog.graphImage" alt="Graph" width="80" />
                </td>
                <td>{{ blog.supportIndicator }}</td>
                <td>{{ blog.resistanceIndicator }}</td>
                <td>{{ blog.dayEMA }}</td>
                <td>{{ blog.RSI }}</td>
                <td>{{ blog.dailyPridiction }}</td>
                <td>{{ blog.weeklyPridiction }}</td>
                <td>{{ blog.yearlyPridiction }}</td>
                 <td>
      <button (click)="editBlog(blog)">Edit</button>
      <button (click)="deleteBlog(blog._id)">Delete</button>
    </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noData>
          <p>No blogs available.</p>
        </ng-template>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>

<c-row *ngIf="Edit">
    <c-col xs="12">
        <c-card class="mb-4">
            <c-card-body>
                <button (click)="listBlog()">Back to List</button>
                <form [formGroup]="form" (ngSubmit)="updateForm()">
                    <c-row class="mb-">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="mainTitle">Main Title</label>
                            <input id="facebookLink" aria-label="mainTitle" cFormControl autoComplete="off"
                                formControlName="mainTitle" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.mainTitle">{{ serverErrors.mainTitle
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="mainParagraph">Main Paragraph </label>
                            <input id="mainParagraph" aria-label="mainParagraph" cFormControl autoComplete="off"
                                formControlName="mainParagraph" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.mainParagraph">{{ serverErrors.mainParagraph }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="image">Upload Image</label>
                            <input cFormControl id="image" sizing="md" type="file" (change)="upload($event)" />
                            <div class="form-group">
                                <div class="preview mt-2" *ngIf="preview && preview !== null">
                                    <img [src]="preview" [alt]="form.value.name">
                                </div>
                                <span class="required" *ngIf="serverErrors?.image">{{
                                    serverErrors.image
                                    }}</span>
                            </div>
                        </c-col>
                        <c-col></c-col>
                    </c-row>
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="coinName">Coin Name</label>
                            <input id="coinName" aria-label="coinName" cFormControl autoComplete="off"
                                formControlName="coinName" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.coinName">{{ serverErrors.coinName
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="coinParagraph">Coin Paragraph</label>
                            <input id="coinParagraph" aria-label="coinParagraph" cFormControl autoComplete="off"
                                formControlName="coinParagraph" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.coinParagraph">{{ serverErrors.coinParagraph }}</span>
                        </c-col>
                    </c-row>
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle1">paragraph Title1</label>
                            <input id="paragraphTitle1" aria-label="paragraphTitle1" cFormControl autoComplete="off"
                                formControlName="paragraphTitle1" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle1">{{ serverErrors.paragraphTitle1
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription1">Paragraph Description1</label>
                            <input id="paragraphDescription1" aria-label="paragraphDescription1" cFormControl autoComplete="off"
                                formControlName="paragraphDescription1" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription1">{{ serverErrors.paragraphDescription1 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle2">paragraph Title2</label>
                            <input id="paragraphTitle2" aria-label="paragraphTitle2" cFormControl autoComplete="off"
                                formControlName="paragraphTitle2" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle2">{{ serverErrors.paragraphTitle2
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription2">Paragraph Description2</label>
                            <input id="paragraphDescription2" aria-label="paragraphDescription2" cFormControl autoComplete="off"
                                formControlName="paragraphDescription2" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription2">{{ serverErrors.paragraphDescription2 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle3">paragraph Title3</label>
                            <input id="paragraphTitle3" aria-label="paragraphTitle3" cFormControl autoComplete="off"
                                formControlName="paragraphTitle3" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle3">{{ serverErrors.paragraphTitle3
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription3">Paragraph Description3</label>
                            <input id="paragraphDescription3" aria-label="paragraphDescription3" cFormControl autoComplete="off"
                                formControlName="paragraphDescription3" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription3">{{ serverErrors.paragraphDescription3 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle4">paragraph Title4</label>
                            <input id="paragraphTitle4" aria-label="paragraphTitle4" cFormControl autoComplete="off"
                                formControlName="paragraphTitle4" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle4">{{ serverErrors.paragraphTitle4
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription4">Paragraph Description4</label>
                            <input id="paragraphDescription4" aria-label="paragraphDescription4" cFormControl autoComplete="off"
                                formControlName="paragraphDescription4" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription4">{{ serverErrors.paragraphDescription4 }}</span>
                        </c-col>
                    </c-row>
                          <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphTitle5">paragraph Title5</label>
                            <input id="paragraphTitle5" aria-label="paragraphTitle5" cFormControl autoComplete="off"
                                formControlName="paragraphTitle5" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphTitle5">{{ serverErrors.paragraphTitle5
                                }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="paragraphDescription5">Paragraph Description5</label>
                            <input id="paragraphDescription5" aria-label="paragraphDescription5" cFormControl autoComplete="off"
                                formControlName="paragraphDescription5" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.paragraphDescription5">{{ serverErrors.paragraphDescription5 }}</span>
                        </c-col>
                    </c-row>

                         <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="graphImage">Upload Graph Image</label>
                            <input cFormControl id="graphImage" sizing="md" type="file" (change)="upload2($event)" />
                            <div class="form-group">
                                <div class="preview mt-2" *ngIf="preview2 && preview2 !== null">
                                    <img [src]="preview2" [alt]="form.value.name">
                                </div>
                                <span class="required" *ngIf="serverErrors?.graphImage">{{
                                    serverErrors.graphImage
                                    }}</span>
                            </div>
                        </c-col>
                        <c-col></c-col>
                    </c-row>
       
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="supportIndicator">support Indicator</label>
                            <input id="supportIndicator" aria-label="supportIndicator" cFormControl autoComplete="off"
                                formControlName="supportIndicator" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.supportIndicator">{{
                                serverErrors.supportIndicator }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="resistanceIndicator">resistance Indicator</label>
                            <input id="resistanceIndicator" aria-label="resistanceIndicator" cFormControl autoComplete="off"
                                formControlName="resistanceIndicator" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.resistanceIndicator">{{ serverErrors.resistanceIndicator
                                }}</span>
                        </c-col>
                    </c-row>

                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="dayEMA">Day EMA</label>
                            <input id="dayEMA" aria-label="dayEMA" cFormControl autoComplete="off"
                                formControlName="dayEMA" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.dayEMA">{{
                                serverErrors.dayEMA }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="RSI">RSI Indicator</label>
                            <input id="RSI" aria-label="RSI" cFormControl autoComplete="off"
                                formControlName="RSI" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.RSI">{{ serverErrors.RSI
                                }}</span>
                        </c-col>
                    </c-row>

                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="dailyPridiction">Daily Pridiction</label>
                            <input id="dailyPridiction" aria-label="dailyPridiction" cFormControl autoComplete="off"
                                formControlName="dailyPridiction" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.dailyPridiction">{{
                                serverErrors.dailyPridiction }}</span>
                        </c-col>
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="weeklyPridiction">Weekly Pridiction</label>
                            <input id="weeklyPridiction" aria-label="weeklyPridiction" cFormControl autoComplete="off"
                                formControlName="weeklyPridiction" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.weeklyPridiction">{{ serverErrors.weeklyPridiction
                                }}</span>
                        </c-col>
                    </c-row>
                    <c-row class="mb-3">
                        <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="yearlyPridiction">yearly Pridiction</label>
                            <input id="yearlyPridiction" aria-label="yearlyPridiction" cFormControl autoComplete="off"
                                formControlName="yearlyPridiction" (input)="onInputChange()" />
                            <span class="required" *ngIf="serverErrors?.yearlyPridiction">{{ serverErrors.yearlyPridiction
                                }}</span>
                        </c-col>
                   
                    </c-row>
      
                    <c-row>
                        <c-col [xs]="12">
                            <button cButton class="btn btn-primary" type="submit">Update</button>
                        </c-col>
                    </c-row>
                </form>
            </c-card-body>
        </c-card>
    </c-col>
</c-row>
